import classNames from 'classnames';
import cs from '../application-details.module.scss';
import { DatePicker, fontStyles } from '@monash/portal-react';
import { Controller } from 'react-hook-form';
import { isValid } from 'date-fns';

const StartDateField = () => {
  return (
    <div className={cs.fieldWrapper}>
      <div
        className={classNames(
          fontStyles.heading,
          fontStyles.sm,
          fontStyles.medium
        )}
      >
        Preferred Start Date
        <span className={cs.required}>*</span>
      </div>
      <Controller
        name="startDate"
        rules={{
          validate: (value) => isValid(value) || 'Select a valid date',
        }}
        render={({ field: { value, onChange, onBlur } }) => (
          <DatePicker selectedDay={value} onBlur={onBlur} onChange={onChange} />
        )}
      />
    </div>
  );
};

export default StartDateField;
